import { compose } from 'recompose';
import { withStyles } from '@mui/styles';
import { styles } from './blue-container.styles';
import BlueContainer from './blue-container';

export default compose(withStyles(styles))(BlueContainer);
